import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { FlexCSS, IconSizesCSS, StyledGrid } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import theme from 'constants/theme';

import TooltipInfo from 'uiToolkit/TooltipInfo';
import { TextHeader2 } from 'uiToolkitV1/Typography';

const HeaderContainer = styled(Grid)`
  padding: ${(props) => (props.withInComponent ? '1.5rem 1.5rem 1.25rem' : '1rem 0 1.25rem')};
  border-bottom: 1px solid #efefef;
  letter-spacing: 0.275px;
`;

const FlexStyledGrid = styled(StyledGrid)`
  ${FlexCSS}
`;

const IconContainer = styled.span`
  color: ${(props) => getColorFromKey(props.color)};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  svg {
    ${(props) => props.size && IconSizesCSS[props.size]};
    fill: ${(props) => getColorFromKey(props.color)};
  }
`;

const SectionHeader = ({ icon, title, withInComponent = true, iconClickHandler, rightContent = null, info = null }) => (
  <HeaderContainer container withInComponent={withInComponent} justify="space-between">
    <FlexStyledGrid item sm={rightContent ? 6 : 12} flexcontainer alignItems="center">
      <IconContainer
        color={theme.palette.icons.mediumGrey}
        size="header"
        onClick={iconClickHandler}
        style={{ marginTop: '1px' }}
      >
        {icon}
      </IconContainer>
      <TextHeader2 bold ml={3}>
        {title}
      </TextHeader2>

      {info && <TooltipInfo title={info.title} linkUrl={info.url} leftGutter={1} />}
    </FlexStyledGrid>
    <FlexStyledGrid item sm={6}>
      {rightContent}
    </FlexStyledGrid>
  </HeaderContainer>
);

export default SectionHeader;
